import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default function(routes) {

    var router = new Router({
        // mode: 'history',
        base: process.env.BASE_URL,
        routes: routes,
    });

    router.beforeEach((to, from, next) => {
        document.title = to.meta.titulo
        next();
    });

    return router

}
